<template>
  <div>
    <div
      class="content-video-card white rounded-5 box-shadow-effect overflow-hidden pointer"
    >
      <template v-if="subscription_status === true">
        <div class="video-card position-relative overflow-hidden">
          <!-- OVERLAY -->
          <div class="position-absolute w-100 index-1 h-100"></div>

          <img v-lazy="thumbnail" alt="" />

          <div
            class="icon-play-bg brand_accent font-35 index-9"
            @click="toggleViewer"
          ></div>
        </div>
      </template>

      <template v-else>
        <div
          class="video-card position-relative overflow-hidden"
          style="cursor: not-allowed"
        >
          <!-- OVERLAY -->
          <div
            class="position-absolute w-100 index-1 h-100 rgba-black-strong"
          ></div>

          <img v-lazy="thumbnail" alt="" />

          <div class="icon-play-bg brand_accent font-40 index-9"></div>
          <div class="icon-lock-fill brand_accent_light font-20"></div>
        </div>
      </template>

      <div class="video-info">
        <div class="video-title font-weight-600 brand_navy" :title="title">
          {{ truncateTitle }}
        </div>
        <div class="video-date color_grey_dark">
          <span class="mr-1">{{ date }}</span>
          <span>{{ time }}</span>
        </div>
        <div class="video-tag brand_primary">{{ tag ? tag : "General" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentVideoCard",

  components: {},

  props: {
    id: Number,
    title: String,
    thumbnail: String,
    date: String,
    time: String,
    filetype: String,
    filename: String,
    tag: String,
    user: Object,
    token: String,
    subscription_status: Boolean,
  },

  computed: {
    truncateTitle() {
      return this.title.length > 45
        ? `${this.title.slice(0, 45)}...`
        : this.title;
    },
  },

  data() {
    return {
      video_data: {
        title: this.title,
        url: this.filename,
        token: this.token,
        date: this.date,
        time: this.time,
        fullname: this.user.full_name,
        image: this.user.image,
        thumbnail: this.thumbnail,
      },
    };
  },

  methods: {
    toggleViewer() {
      this.$bus.$emit("event-bus-show-library-video", this.video_data);
    },
  },
};
</script>

<style lang="scss">
.content-video-card {
  @include flex_row_start_nowrap;
  margin-bottom: 20px;
  transition: all 0.4s ease-in-out;

  @include breakpoint_max(xs) {
    margin-bottom: 10px;
  }

  &:hover {
    transform: scale(0.98);
  }

  .video-card {
    @include equal_min_edge(115);
    @include flex_row_center_nowrap;
    background: $brand_inverse_light;

    @include breakpoint_max(sm) {
      @include equal_min_edge(85);
    }

    @include breakpoint_max(xs) {
      @include equal_min_edge(78);
    }

    img {
      @include img_cover;
    }

    .icon-play-bg {
      @include transform_center;

      @include breakpoint_max(sm) {
        font-size: 30px !important;
      }

      @include breakpoint_max(xs) {
        font-size: 25px !important;
      }
    }

    .icon-lock-fill {
      @include transform_center;
      z-index: 99;
    }
  }

  .video-info {
    padding: 10px;

    @include breakpoint_max(xs) {
      padding: 7px 8px;
    }

    .video-title {
      font-size: 13.5px;
      line-height: 21px;
      margin-bottom: 2px;

      @include breakpoint_max(sm) {
        font-size: 12.5px;
        line-height: 18px;
        font-weight: 500 !important;
      }

      @include breakpoint_max(xs) {
        line-height: 17px;
      }
    }

    .video-date {
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 20px;

      @include breakpoint_max(sm) {
        font-size: 10px;
        line-height: 15px;
        margin-bottom: 16px;
      }

      @include breakpoint_max(xs) {
        margin-bottom: 12px;
      }
    }

    .video-tag {
      font-size: 12px;
      line-height: 16px;

      @include breakpoint_max(sm) {
        font-size: 11px;
      }
    }
  }
}
</style>
